module.exports = __webpack_public_path__ + "static/img/autCt_bg_02.17716cc7.svg";